import { render } from "./AddNewUserView.vue?vue&type=template&id=3879bbe0"
import script from "./AddNewUserView.vue?vue&type=script&lang=js"
export * from "./AddNewUserView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__